import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

interface LoginCredentials {
  clientId: string;
  clientSecret: string;
}

interface TokenResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
}

export const loginUser = async (credentials: LoginCredentials): Promise<TokenResponse> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/oauth/token`, {
      clientId: credentials.clientId,
      clientSecret: credentials.clientSecret,
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 401) {
      throw new Error('Invalid client credentials');
    }
    throw new Error('Login failed. Please try again.');
  }
}; 